// instance methods
export const INSTANCE_METHODS = {
    CLEAR_CURRENT_CELL_RECT: "clearCurrentCellRect",
    CLEAR_NORMAL_END_CELL_RECT: "clearNormalEndCellRect",
};
